/* eslint-disable semi */
/* eslint-disable space-before-function-paren */
export default {
  data() {
    return {
      authenticationInterval: null
    };
  },
  methods: {
    getClinicId() {
      let clinicId = this.$route.params.clinic_id;
      let storageClinicId = this.getFromLocalStorage('clinicId');

      return clinicId || storageClinicId;
    },
    isMine(targetId) {
      let currentUser = this.$auth.user();
      return currentUser.id === targetId;
    },
    isAdmin() {
      let invoicesPermission = this.$auth.user().see_invoices;
      let financialPermission = this.$auth.user().see_financial;
      let approvePermission = this.$auth.user().can_approve;
      let transactionPermission = this.$auth.user().can_make_transaction;

      return (
        invoicesPermission &&
        financialPermission &&
        approvePermission &&
        transactionPermission
      );
    },
    doctorVisitPermissions(targetId) {
      const currentUser = this.$auth.user();
      if (this.isAdmin()) {
        return true;
      }

      if (this.$auth.check('doctor') && currentUser.id !== targetId) {
        return false;
      }

      return true;
    },
    titleCase(title) {
      return window._.startCase(window._.toLower(title));
    },
    getAge(birthdayDate) {
      return window.moment().diff(birthdayDate, 'years');
    },
    getPatientDividedName(name) {
      if (typeof name === 'string') {
        const names = name.split('/');

        return {
          firstName: names[0] || undefined,
          middleName: names[1] || undefined,
          lastName: names[2] || undefined
        };
      }
      return {
        firstName: undefined,
        lastName: undefined,
        middleName: undefined
      };
    },
    capitalizeWords(string) {
      return string.replace(/(?:^|\s)\S/g, function(a) {
        return a.toUpperCase();
      });
    },
    adjustName(name) {
      if (typeof name === 'string') {
        return this.capitalizeWords(this.escapeBackSlashString(name));
      }
      return '';
    },
    escapeBackSlashString(s) {
      if (typeof s === 'string') return s.replace(/\//g, ' ');
      return '';
    },
    getGender(genderNumber) {
      return Number(genderNumber) === 1 ? this.$t('male') : this.$t('female');
    },
    getMaritalStatus(maritalStatusNumber) {
      return Number(maritalStatusNumber) === 1
        ? this.$t('married')
        : this.$t('single');
    },
    emptyUser() {
      return window._.isEmpty(this.$auth.user());
    },
    isDateTimeAfterNow(time) {
      return window.moment() < window.moment(time);
    },
    isEmpty(value) {
      return window._.isEmpty(value);
    },
    formatPrice(amount, fixedTo = 2) {
      return (
        Number(amount)
          .toFixed(fixedTo)
          .replace(/\d(?=(\d{3})+\.)/g, '$&,') + ' E£'
      );
    },
    saveToLocalStorage(key, data) {
      window.localStorage.setItem(key, data);
      document.dispatchEvent(new Event('clinicId-changed'));
    },
    removeFromLocalStorage(key) {
      window.localStorage.removeItem(key);
      document.dispatchEvent(new Event('clinicId-changed'));
    },
    getFromLocalStorage(key) {
      return window.localStorage.getItem(key);
    },
    getReservationStatus(reservation) {
      let reservationTime = window.moment(reservation.time).add(5, 'hours');
      let now = window.moment();
      let reservationPassed = now > reservationTime && !reservation.started_at;

      if (reservation.cancelled_at) {
        return this.$t('cancelled');
      } else if (reservation.finished_at) {
        return this.$t('finished');
      } else if (reservationPassed) {
        return this.$t('passed');
      } else if (!reservation.started_at) {
        return this.$t('pending');
      }
      return this.$t('inProgress');
    },
    navigateTo(routeName, fieldsObject) {
      if (fieldsObject && fieldsObject.key) {
        this.$router.push({
          name: routeName,
          [fieldsObject.key]: fieldsObject.value || {}
        });
      } else {
        this.$router.push({ name: routeName });
      }
    },
    getSpecializations() {
      return this.$fetchingFromApi.specializations();
    },
    getClinicInfo() {
      return this.$fetchingFromApi.clinicInfo();
    },
    getReservationTypes() {
      return this.$fetchingFromApi.reservationTypes();
    },
    getUnitMeasurements() {
      return this.$fetchingFromApi.unitMeasurements();
    },
    getClinics() {
      return this.$fetchingFromApi.clinics();
    },
    getDoctors() {
      return this.$fetchingFromApi.doctors();
    },
    getPermissions() {
      return this.$fetchingFromApi.permissions();
    },
    getSettings(id) {
      return this.$fetchingFromApi.settings(id);
    },
    checkAuthenticationReady(callback) {
      this.authenticationInterval = setInterval(() => {
        if (this.$auth.ready() && this.$auth.token()) {
          callback();
        }
      }, 1000 * 5);
    },
    fetchData() {
      if (!this.isDataFetched()) {
        this.axios.all(this.authorizationRequiredData()).then(
          this.axios.spread(() => {
            clearInterval(this.authenticationInterval);
          })
        );
      }
    },
    authorizationRequiredData() {
      if (this.$auth.check('doctor') || this.$auth.check('manager')) {
        return this.doctorsData();
      } else {
        return this.employeesData();
      }
    },
    getVisitRequiredSource() {
      return this.settings[0].value.fields[0]
    },
    getVisitStatusesAllowedForTheDoctor() {
      return this.settings[2].value
    },
    logout() {
      this.$auth.logout({
        success: () => {
          this.$fetchingFromApi.stopPolling();
          this.removeFromLocalStorage('clinicId');
          this.clearCachedData();
        },
        error: err => {
          console.log(err);
        }
      });
    },
    clearCachedData() {
      this.$store.commit('clearAllCachedData');
    },
    doctorsData() {
      return [
        this.getSpecializations(),
        this.getClinicInfo(),
        this.getDoctors(),
        this.getUnitMeasurements(),
        this.getClinics(),
        this.getPermissions()
      ];
    },
    employeesData() {
      return [
        this.getClinicInfo(),
        this.getUnitMeasurements(),
        this.getDoctors(),
        this.getClinics(),
        this.getPermissions(),
      ];
    },
    getEndTime(startTime, duration) {
      let computedEndTime = window
        .moment(startTime)
        .add(duration, 'hours')
        .toDate();
      return computedEndTime;
    },
    isAvalibleDate(date, reservationsDates, mode) {
      if (mode === 'day') {
        let dayReservations = window._.filter(
          reservationsDates,
          reservationDates => {
            let momentDate = window.moment(date);
            let momentTime = window.moment(reservationDates.time);
            return (
              !reservationDates.cancelled_at &&
              momentDate.isSame(momentTime, mode)
            );
          }
        );

        return this.hasEmptySlot(dayReservations);
      } else {
        let avalible = true;
        window._.each(reservationsDates, reservationDates => {
          let reservationType = this.reservationTypes.find(
            reservationDates.reservation_type_id
          );

          let reservationTime = window
            .moment(reservationDates.time)
            .add(1, 'days');
          let now = window.moment();
          let reservationPassed =
            now > reservationTime && !reservationDates.started_at;

          // Reservation Cases:
          // 1- Reservation is cancelled.
          // 2- Reservation time is passed.
          // 3- Reservation is done
          // 4- Reservation is in progress
          // 5- Reservation is pending

          if (reservationDates.cancelled_at) {
            avalible = avalible && true;
          } else if (reservationPassed) {
            avalible = avalible && true;
          } else if (
            reservationDates.started_at &&
            reservationDates.finished_at
          ) {
            avalible =
              avalible &&
              this.timeInReservation(
                date,
                reservationDates.started_at,
                reservationDates.finished_at
              );
          } else if (reservationDates.started_at) {
            let expectedEndTime = this.getEndTime(
              reservationDates.started_at,
              reservationType.duration
            );
            avalible =
              avalible &&
              this.timeInReservation(
                date,
                reservationDates.started_at,
                expectedEndTime
              );
          } else {
            let expectedEndTime = this.getEndTime(
              reservationDates.time,
              reservationType.duration
            );
            avalible =
              avalible &&
              this.timeInReservation(
                date,
                reservationDates.time,
                expectedEndTime
              );
          }
        });

        return avalible;
      }
    },
    timeInReservation(date, startTime, endTime, mode) {
      let momentDate = window.moment(date);
      let momentStartTime = window.moment(startTime);
      let momentEndTime = window.moment(endTime);
      return (
        momentDate.isBetween(momentStartTime, momentEndTime) ||
        momentDate.isSame(momentStartTime) ||
        momentDate.isSame(momentEndTime)
      );
    },
    hasEmptySlot(dayReservations) {
      let totalBusyTime = 0;
      window._.each(dayReservations, reservationDates => {
        let reservationType = this.reservationTypes.find(
          reservationDates.reservation_type_id
        );
        if (reservationType.duration > 0) {
          if (reservationDates.cancelled_at) {
            totalBusyTime += 0;
          } else if (
            reservationDates.started_at &&
            reservationDates.finished_at
          ) {
            let momentStartTime = window.moment(reservationDates.started_at);
            let momentEndTime = window.moment(reservationDates.finished_at);

            totalBusyTime += window.moment
              .duration(momentEndTime.diff(momentStartTime))
              .asSeconds();
          } else {
            let startTime = reservationDates.started_at
              ? reservationDates.started_at
              : reservationDates.time;
            let expectedEndTime = window.moment(
              this.getEndTime(startTime, reservationType.duration / 3600)
            );
            let momentStartTime = window.moment(startTime);

            totalBusyTime += window.moment
              .duration(expectedEndTime.diff(momentStartTime))
              .asSeconds();
          }
        }
      });

      let maximumDuration = window._.maxBy(
        this.reservationTypes,
        reservationType => {
          return Number(reservationType.duration);
        }
      );

      return 12 * 3600 - totalBusyTime > maximumDuration.duration;
    },
    changeStyleSheet(lang) {
      if (lang === 'en') {
        document
          .getElementById('pageStyle')
          .setAttribute('href', 'static/semantic/semantic.min.css');
        document
          .getElementById('customeStyle')
          .setAttribute('href', 'static/css/ltrStyles.css');
        this.$i18n.locale = lang;
      } else if (lang === 'ar') {
        document
          .getElementById('pageStyle')
          .setAttribute('href', 'static/semantic/semantic.rtl.min.css');
        document
          .getElementById('customeStyle')
          .setAttribute('href', 'static/css/rtlStyles.css');
        this.$i18n.locale = lang;
      }
    },
    pageData(data, pageNumber, dataPerPage) {
      let startIndex = dataPerPage * (pageNumber - 1);
      return data.slice(startIndex, startIndex + dataPerPage);
    },
    isDataFetched() {
      if (this.$auth.check('doctor') || this.$auth.check('manager')) {
        return (
          !this.isEmpty(this.clinic) &&
          !this.isEmpty(this.specializations) &&
          !this.isEmpty(this.doctorsMeta) &&
          !this.isEmpty(this.permissions) &&
          !this.emptyUser() &&
          this.clinics.length > 0
        );
      } else if (this.$auth.check('employee')) {
        return (
          !this.isEmpty(this.clinic) &&
          !this.isEmpty(this.doctorsMeta) &&
          !this.isEmpty(this.permissions) &&
          this.clinics.length > 0 &&
          !this.emptyUser()
        );
      }
    },
    setClinicToStore(clinic) {
      this.$store.commit('fetchDataToCache', { key: 'clinic', value: clinic });
    },
    setHomeCurrentDate(date) {
      this.$store.commit('fetchDataToCache', { key: 'homeCurrentDate', value: date});
    }
  },
  computed: {
    direction() {
      return this.$i18n.locale === 'en' ? 'ltr' : 'rtl';
    },
    clinic() {
      return this.$store.getters.clinic;
    },
    clinics() {
      return this.$store.getters.clinics;
    },
    specializations() {
      return this.$store.getters.specializations;
    },
    reservationTypes() {
      return this.$store.getters.reservationTypes;
    },
    unitMeasurements() {
      return this.$store.getters.unitMeasurements;
    },
    permissions() {
      return this.$store.getters.permissions;
    },
    doctorsMeta() {
      return this.$store.getters.doctorsMeta;
    },
    settings() {
      return this.$store.getters.settings;
    },
    homeCurrentDate() {
      return this.$store.getters.homeCurrentDate;
    },
    globalColor() {
      return this.$auth.user().color;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/global.js